import React, { useContext } from 'react';
import '../../../styles/irctcPasswordSent.css';
import FacingTrouble from '../../components/FacingTrouble';
import { getAppEnv } from '../../../../config/env';
import {
  FACING_TROUBLE_PAGE_TITLE,
  getContinueBookingUrl,
  getFacingTroubleList,
  IRCTC_PASSWORD_RADIO,
  SERVER_URL
} from '../../../utils/RailsSEOConstants';
import axios from 'axios';
import { isMobile, navigateTo } from '../../../utils/commonUtils';
import { IrctcForgotPasswordContext } from '../IrctcForgotPasswordPage';
import useTimer from '../../components/useTimer';
import PropTypes from 'prop-types';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const IrctcPasswordSent = (props) => {
  const { customClass } = props;

  const context = useContext(IrctcForgotPasswordContext);
  const { modeOfPasswordSent, userName, userEmail, mobileNumber } = context;
  const { timerString, timerExpired } = useTimer(120);
  const handleResendPasswordClick = async () => {
    if (timerExpired) {
      try {
        // make API request
        await axios.get(`${SERVER_URL}/user/irctc/details/P`, {
          params: {
            userLoginId: userName || '',
            email: IRCTC_PASSWORD_RADIO[modeOfPasswordSent].key === IRCTC_PASSWORD_RADIO.EMAIL.key ? userEmail : '',
            mobile:
              IRCTC_PASSWORD_RADIO[modeOfPasswordSent].key === IRCTC_PASSWORD_RADIO.MOBILE.key ? mobileNumber : '',
            otpType: IRCTC_PASSWORD_RADIO[modeOfPasswordSent].otpType,
            dob: ''
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
  const emailDetails = modeOfPasswordSent === IRCTC_PASSWORD_RADIO.EMAIL.key ? `email address ${userEmail}` : '';
  const mobileDetails =
    modeOfPasswordSent === IRCTC_PASSWORD_RADIO.MOBILE.key ? `mobile number +91${mobileNumber}` : '';
  const isMobileDevice = isMobile();
  return (
    <div className={`${customClass} irctcPwdSent`}>
      <div className="irctcPwdSent__cntnt">
        <div className="imgWrap">
          <img src={`${PUBLIC_URL}/static/public/tickIcon.png`} alt={''} />
        </div>
        <h3>New Password Sent</h3>
        <div>
          <span className="appendBottom40">
            Your password has been sent to your registered{' '}
            <span className="latoBlack">{`${emailDetails || mobileDetails}`}</span>
          </span>
        </div>

        <div className="makeFlex hrtlCenter appendTop10">
          <span className="appendRight15">Didn’t receive Password?</span>
          <p className="timeTag">
            <span className="railSeoSprite whiteClock appendRight8" />
            {timerString}
          </p>
        </div>
        <a onClick={handleResendPasswordClick} className={timerExpired ? '' : 'noDrop'}>
          Resend Password
        </a>
        <button
          className={`blueButtonRails ${isMobileDevice ? 'fullWidth' : ''}`}
          onClick={() => navigateTo(getContinueBookingUrl())}
        >
          Continue Booking
        </button>
      </div>
      <FacingTrouble facingTroubleList={getFacingTroubleList(FACING_TROUBLE_PAGE_TITLE.FORGOT_IRCTC_PASSWORD_TITLE)} />
    </div>
  );
};

IrctcPasswordSent.propTypes = {
  customClass: PropTypes.string
};

export default IrctcPasswordSent;
